/**
 * @packageDocumentation
 *
 * The AutoNAT service uses the [AutoNAT protocol](https://docs.libp2p.io/concepts/nat/autonat/).
 * The service confirms addresses are dialable by remote peers, and updates the list it advertises.
 *
 * The service dials randomly selected peers with a request to verify it's external addresses.
 * The request includes a list of public multiaddrs (addressManager.getObservedAddrs()).
 * The remote peers dial that list and respond with the results.
 *
 * The AutoNAT service uses those responses to either:
 * - addressManager.confirmObservedAddr(addr)
 * - addressManager.removeObservedAddr(addr)
 *
 * The result list of candidates and confirmed addresses can be found
 * at addressManager.getObservedAddrs()
 *
 * @example
 *
 * ```typescript
 * import { createLibp2p } from 'libp2p'
 * import { autoNAT } from '@libp2p/autonat'
 *
 * const node = await createLibp2p({
 *   // ...other options
 *   services: {
 *     autoNAT: autoNAT()
 *   }
 * })
 * ```
 */
import { AutoNATService } from './autonat.js';
export function autoNAT(init = {}) {
    return (components) => {
        return new AutoNATService(components, init);
    };
}
//# sourceMappingURL=index.js.map